<template>
    <div class="page-content">
        <section class="info-section">
            <manage-cards></manage-cards>
            <how-it-works></how-it-works>
        </section>
    </div>
</template>

<script>
import ManageCards from '@/components/Home/manage-cards';
import HowItWorks from '@/components/Home/how-it-works';
export default {
    name: 'info-section',
    components: {
        ManageCards,
        HowItWorks,
    },
};
</script>
<style lang="scss" scoped>
.page-content {
    width: 100%;
    .info-section {
        margin: 0 auto 68px auto;
        overflow: hidden;
    }
}
</style>
